import { CircularProgress } from "@mui/material";
import Button from "./Button";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { HistoricalChart } from "../config/api";
import { chartDays } from "../config/data";
import { CryptoState } from "../CryptoContext";
import styles from "./coininfo.module.css";

const CoinInfo = ({ coin }) => {
  const [historicalData, setHistoricalData] = useState();
  const [days, setDays] = useState(1);
  const { currency } = CryptoState();

  const fetchHistoricalData = async () => {
    const { data } = await axios.get(HistoricalChart(coin.id, days, currency));
    setHistoricalData(data.prices);
  };

  useEffect(() => {
    fetchHistoricalData();
  }, [currency, days]);

  if (historicalData) console.log();
  return (
    <div className={styles.container}>
      <div>
        {!historicalData ? (
          <CircularProgress size={250} style={{ color: "gold" }} />
        ) : (
          <div>
            <Line
              data={{
                labels: historicalData.map((coin) => {
                  let date = new Date(coin[0]);
                  let time =
                    date.getHours() > 12
                      ? `${date.getHours() - 12}:${date.getMinutes()} PM`
                      : `${date.getHours()}:${date.getMinutes()} AM`;
                  return days === 1 ? time : date.toLocaleDateString();
                }),

                datasets: [
                  {
                    data: historicalData.map((coin) => coin[1]),
                    label: `Price ( Past ${days} Days ) in ${currency}`,
                    borderColor: "#EEBC1D",
                  },
                ],
              }}
              options={{
                elements: {
                  point: {
                    radius: 0.5,
                  },
                },
              }}
            />
          </div>
        )}
      </div>

      <div
        style={{
          display: "flex",
          marginTop: 20,
          justifyContent: "space-around",
          width: "100%",
          padding: 30,
          gap: 10
        }}
      >
        {chartDays.map((day) => (
          <Button
            key={day.value}
            onClick={() => {
              setDays(day.value);
              // setflag(false);
            }}
            selected={day.value === days}
          >
            {day.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default CoinInfo;
